import React, {useState, useEffect} from 'react';
import {Copyright, Header} from "../components";
import Typography from "@mui/material/Typography";
import {Paper, Box, Button, TextField, Grid} from "@material-ui/core";
import useStyles from "../assets/styles/useStyles";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router";
import usePOST from "../hooks/usePOST";

function AddCompany() {

    const [responsePost, sendPostRequest] = usePOST();
    const [name, setName] = useState('')
    const [siret, setSiret] = useState('')
    const [logoLink, setLogoLink] = useState('')
    const [sentRequest, setSentRequest] = useState({name: '', siret: '', logo: ''});

    const [companyAdded, setCompanyAdded] = useState(false);
    const [error, setError] = useState({siret: false})


    const navigate = useNavigate();
    const reduxUser = useSelector(state => state.userReducer.user);

    const classes = useStyles();

    useEffect(() => {
        if (!reduxUser.roles?.includes('ROLE_MASTER')) {
            navigate("/")
        }
    }, [reduxUser.roles, navigate])

    const submitHandler = async (event) => {
        event.preventDefault();

        let siretErr = document.getElementById("siret-error");
        siretErr.style.display = "none";
        setError({siret: false})
        document.getElementById("add-error").style.display = "none"

        if (!(siret.length === 14)) {
            setError({siret: true})
            siretErr.style.display = "block";
            return;
        }
        setSentRequest({
            name: name,
            siret: siret,
            logo: logoLink,
        })

        await sendPostRequest({
            id: 'addCompany',
            url: '/api/companies/addCompany',
            data: sentRequest,
            headers: {Authorization: `Bearer ${reduxUser.token}`}
        })
    }

    useEffect(() => {
        const response = responsePost['addCompany']
        if (!response) return;

        let addError = document.getElementById("add-error");
        let nonUniqueSiret = document.getElementById("non-unique-siret")
        addError.style.display = "none";
        nonUniqueSiret.style.display = "none";
        setCompanyAdded(false)

        try {
            if (response.status >= 200 && response.status < 300) {
                setCompanyAdded(true);
            } else if (response.status === 409) {
                nonUniqueSiret.style.display = "block";
            } else {
                addError.style.display = "block";
            }
        } catch (err) {
            console.log("error while adding company:", err);
            addError.style.display = "block";
        }
    }, [responsePost])

    return (
        <Grid container direction="column">
            <Grid item>
                <Header/>
            </Grid>

            <Grid item>
                <Grid
                    container
                    justifyContent="center"
                    style={{marginTop: 50}}
                >
                    <Paper elevation={3} className={classes.paper}>
                        <Typography
                            component="h1"
                            variant="h3"
                            align="center"
                            gutterBottom
                        >
                            Ajouter une entreprise
                        </Typography>

                        <Typography id="add-error" className={classes.message} align="center">
                            Erreur lors de l'ajout de l'entreprise.
                        </Typography>

                        <Typography id="siret-error" className={classes.message} align="center">
                            Le SIRET n'est pas assez long.
                        </Typography>

                        <Typography id="non-unique-siret" className={classes.message} align="center">
                            Ce SIRET existe déjà dans la base de données.
                        </Typography>

                        {companyAdded && (<Typography id="company-added" className={classes.confirm} align="center">
                            L'entreprise {sentRequest.name} (SIRET: {sentRequest.siret}) a bien été ajoutée.
                        </Typography>)}

                        <form
                            className={classes.form}
                            onSubmit={submitHandler}
                        >
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        label="Nom de l'entreprise"
                                        value={name}
                                        onChange={(e) =>
                                            setName(e.target.value)
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        label="SIRET"
                                        error={error.siret}
                                        value={siret}
                                        onChange={(e) =>
                                            setSiret(e.target.value)
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={logoLink ? 9 : 12}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                label="Lien de l'image du logo (facultatif)"
                                                value={logoLink}
                                                onChange={(e) => setLogoLink(e.target.value)}
                                            />
                                        </Grid>

                                        {logoLink && (
                                            <Grid item xs={3}>
                                                <img
                                                    src={logoLink}
                                                    alt="Aperçu logo"
                                                    style={{
                                                        maxHeight: 60,
                                                        maxWidth: "100%",
                                                        objectFit: "contain",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                    }}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = "";
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Box display="flex" justifyContent="center">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className={classes.submit}
                                >
                                    Envoyer
                                </Button>
                            </Box>
                        </form>
                    </Paper>
                </Grid>
            </Grid>

            <Box mt={5}>
                <Copyright/>
            </Box>
        </Grid>
    );
}

export default AddCompany;
